export const queryKeys = {
  REALTOR_BOOKING_LEAD: 'REALTOR_BOOKING_LEAD'
};
